export default {
    key: 'installed_production_capacity',
    slug: 'installed-production-capacity',
    variants: [
        {
            key: 'by_sector',
            slug: 'by-sector',
            series: [
                'myc_installed_production_capacity_in_agriculture_chp_biogas',
                'myc_installed_production_capacity_in_agriculture_chp_gas_dispatchable',
                'myc_installed_production_capacity_in_agriculture_chp_gas_must_run',
                'myc_installed_production_capacity_in_agriculture_chp_wood_pellets',
                'myc_installed_production_capacity_in_energy_power_supercritical_coal',
                'myc_installed_production_capacity_in_energy_power_combined_cycle_coal',
                'myc_installed_production_capacity_in_energy_power_combined_cycle_ccs_coal',
                'myc_installed_production_capacity_in_energy_power_ultra_supercritical_coal',
                'myc_installed_production_capacity_in_energy_power_ultra_supercritical_cofiring_coal',
                'myc_installed_production_capacity_in_energy_power_ultra_supercritical_ccs_coal',
                'myc_installed_production_capacity_in_coal_gas_chp',
                'myc_installed_production_capacity_in_coal_gas_ccgt',
                'myc_installed_production_capacity_in_diesel_engine',
                'myc_installed_production_capacity_in_gas_ccgt_dispatchable',
                'myc_installed_production_capacity_in_gas_ccgt_must_run',
                'myc_installed_production_capacity_in_gas_ccgt_ccs',
                'myc_installed_production_capacity_in_gas_conv',
                'myc_installed_production_capacity_in_gas_engine',
                'myc_installed_production_capacity_in_gas_turbine_dispatchable',
                'myc_installed_production_capacity_in_gas_turbine_must_run',
                'myc_installed_production_capacity_in_lignite',
                'myc_installed_production_capacity_in_lignite_oxy',
                'myc_installed_production_capacity_in_industry_chp_gas_ccgt',
                'myc_installed_production_capacity_in_industry_chp_gas_turbine',
                'myc_installed_production_capacity_in_industry_chp_gas_engine',
                'myc_installed_production_capacity_in_industry_chp_hydrogen_turbine',
                'myc_installed_production_capacity_in_industry_chp_wood',
                'myc_installed_production_capacity_in_industry_chp_coal',
                'myc_installed_production_capacity_in_nuclear_iii',
                'myc_installed_production_capacity_in_nuclear_ii',
                'myc_installed_production_capacity_in_nuclear_smr',
                'myc_installed_production_capacity_in_oil_plant',
                'myc_installed_production_capacity_in_buildings_solar_pv_solar_radiation',
                'myc_installed_production_capacity_in_households_solar_pv_solar_radiation',
                'myc_installed_production_capacity_in_energy_power_solar_pv_solar_radiation',
                'myc_installed_production_capacity_in_energy_power_solar_pv_offshore',
                'myc_installed_production_capacity_in_battery_solar_pv',
                'myc_installed_production_capacity_in_energy_power_solar_csp_solar_radiation',
                'myc_installed_production_capacity_in_energy_interconnectors_imported_electricity',
                'myc_installed_production_capacity_in_geothermal',
                'myc_installed_production_capacity_in_coastal_wind_turbines',
                'myc_installed_production_capacity_in_hydrogen_ccgt',
                'myc_installed_production_capacity_in_hydrogen_turbine',
                'myc_installed_production_capacity_in_offshore_wind_turbines',
                'myc_installed_production_capacity_in_offshore_hybrid_wind_turbines',
                'myc_installed_production_capacity_in_onshore_wind_turbines',
                'myc_installed_production_capacity_in_battery_wind_inland',
                'myc_installed_production_capacity_in_hydro_mountain',
                'myc_installed_production_capacity_in_hydro_river',
                'myc_installed_production_capacity_in_wood_pellets_power_must_run',
                'myc_installed_production_capacity_in_wood_pellets_power_dispatchable',
                'myc_installed_production_capacity_in_wood_pellets_power_ccs_must_run',
                'myc_installed_production_capacity_in_wood_pellets_power_ccs_dispatchable',
                'myc_installed_production_capacity_in_waste_power',
                'myc_installed_production_capacity_in_waste_power_ccs',
                'myc_installed_production_capacity_in_biogas_chp',
                'myc_installed_production_capacity_in_coal_chp_pwd_cofiring',
                'myc_installed_production_capacity_in_coal_chp_pwd',
                'myc_installed_production_capacity_in_gas_chp_ccgt',
                'myc_installed_production_capacity_in_hydrogen_chp_ccgt',
                'myc_installed_production_capacity_in_gas_chp_engine',
                'myc_installed_production_capacity_in_lignite_chp',
                'myc_installed_production_capacity_in_waste_chp_ccs',
                'myc_installed_production_capacity_in_waste_chp',
                'myc_installed_production_capacity_in_wood_pellets_chp_ccs_dispatchable',
                'myc_installed_production_capacity_in_wood_pellets_chp_ccs_must_run',
                'myc_installed_production_capacity_in_wood_pellets_chp_must_run',
                'myc_installed_production_capacity_in_wood_pellets_chp_dispatchable'
            ]
        }
    ]
}
